import type { LicenciaProductoProps } from '../interfaces/licenciaProducto'

/**
 * Vigencia de una licencia de producto (IMPRESION, WHATSAPP...): estado ACTIVADO y fecha de
 * vencimiento no pasada. `fechaVencimiento` llega del backend como "DD/MM/YYYY HH:mm:ss".
 * @author isi-template
 */

/** "28/10/2027 00:00:00" → Date (hora local); null si no tiene ese formato */
export const fechaVencimientoLicencia = (licencia?: Partial<LicenciaProductoProps> | null): Date | null => {
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/.exec(
    (licencia?.fechaVencimiento ?? '').trim(),
  )
  if (!m) return null
  const [, d, mes, a, h = '0', min = '0', s = '0'] = m
  const fecha = new Date(Number(a), Number(mes) - 1, Number(d), Number(h), Number(min), Number(s))
  return Number.isNaN(fecha.getTime()) ? null : fecha
}

/** La fecha de vencimiento ya pasó. Sin fecha legible no se considera vencida */
export const licenciaVencida = (licencia?: Partial<LicenciaProductoProps> | null, ahora = new Date()) => {
  const vence = fechaVencimientoLicencia(licencia)
  return vence != null && vence.getTime() <= ahora.getTime()
}

/** Licencia utilizable: ACTIVADO y sin vencer */
export const licenciaVigente = (licencia?: Partial<LicenciaProductoProps> | null, ahora = new Date()) =>
  licencia?.state === 'ACTIVADO' && !licenciaVencida(licencia, ahora)

/** Fecha de vencimiento para mostrar, ej. "28/10/2027" */
export const fechaVencimientoTexto = (licencia?: Partial<LicenciaProductoProps> | null) =>
  (licencia?.fechaVencimiento ?? '').trim().split(/\s+/)[0] ?? ''
